import { useState, useRef } from "react";
import { toast } from "react-toastify"; // ✅ Toast import
import api from "../../utils/axiosConfig.js";
import { useModalAccessibility } from "../../hooks/useModalAccessibility";
// import "./CreateGroupModal.css";

const CreateGroupModal = ({ showModal, onClose, onGroupCreated }) => {
  // const [step, setStep] = useState(1);
  const [groupName, setGroupName] = useState("");
  // const [selectedPrivacy, setSelectedPrivacy] = useState("personal");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const modalRef = useRef(null);

  const handleCloseModal = () => {
    onClose();
    setGroupName("");
    setError("");
    // setStep(1);
    setLoading(false);
  };

  useModalAccessibility({
    isOpen: showModal,
    onClose: handleCloseModal,
    modalRef,
  });

  const handleCreateGroup = async () => {
    setError("");
    if (!groupName.trim()) {
      setError("Please enter an album name");
      return;
    }

    setLoading(true);
    try {
      const res = await api.post(
        "/groups/create",
        { name: groupName.trim(), privacy: "personal" }
      );

      toast.success(`✅ Album Created! Code: ${res.data.group.code}`, {
        position: "top-center",
        autoClose: 4000,
      });

      onGroupCreated(res.data.group);
      handleCloseModal();
    } catch (err) {
      console.error(err);
      const message = err.response?.data?.message || "⚠️ Server error while creating album";
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  if (!showModal) return null;

  return (
    <div className="modal-overlay">
      <div 
        className="modal-content"
        ref={modalRef}
        tabIndex={-1}
        style={{ outline: "none" }}
        role="dialog"
        aria-modal="true"
        aria-labelledby="create-group-title"
      >
        <span 
          className="close-btn" 
          onClick={handleCloseModal}
          aria-label="Close"
          role="button"
          tabIndex={0}
          onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") handleCloseModal(); }}
        >
          &times;
        </span>

        <h2 id="create-group-title">Create Album</h2>
        <p style={{ color: "#6b7280", marginBottom: "16px" }}>Enter album name to create a new album</p>

        <form onSubmit={(e) => { e.preventDefault(); handleCreateGroup(); }}>
          <input
            type="text"
            placeholder="Enter Album Name"
            value={groupName}
            onChange={(e) => {
              setError("");
              setGroupName(e.target.value);
            }}
            autoFocus
          />

          <button 
            type="submit" 
            className="btn btn-primary next-btn" 
            disabled={loading}
            style={{ width: "100%", cursor: loading ? "not-allowed" : "pointer", marginTop: "16px" }}
          >
            {loading ? "Creating..." : "Create Album"}
          </button>

          {error && (
            <p
              style={{
                color: "#ef4444",
                fontSize: "14px",
                fontWeight: "600",
                marginTop: "12px",
                marginBottom: "0",
                textAlign: "center",
                backgroundColor: "#fef2f2",
                padding: "8px 12px",
                borderRadius: "8px",
                border: "1px solid #fee2e2",
              }}
            >
              ⚠️ {error}
            </p>
          )}
        </form>

        {/* 
        ===== COMMENTED OUT: STEP 2 PRIVACY SETTINGS =====
        <div className="privacy-option-container" role="radiogroup" aria-labelledby="create-group-title">
          <div
            className={`privacy-option ${selectedPrivacy === "personal" ? "selected" : ""}`}
            onClick={() => setSelectedPrivacy("personal")}
            role="radio"
            aria-checked={selectedPrivacy === "personal"}
            tabIndex={0}
          >
            <h4>Small Personal Group</h4>
            <p>✅ Face recognition</p>
            <p>✅ View all other photos and folders</p>
          </div>

          <div
            className={`privacy-option ${selectedPrivacy === "public" ? "selected" : ""}`}
            onClick={() => setSelectedPrivacy("public")}
            role="radio"
            aria-checked={selectedPrivacy === "public"}
            tabIndex={0}
          >
            <h4>Big Public Group</h4>
            <p>✅ Face recognition</p>
            <p>⚠️ Admin can choose members who have all photos access</p>
          </div>
        </div>
        */}
      </div>
    </div>
  );
};

export default CreateGroupModal;
